import type { AutocompleteOption } from '@lmn/common-search-widget';
import type {
  PrompterAirportOption,
  PrompterDestinationOption,
} from '@lmn/common-search-widget/api/sources/prompter/types';
import type { PlaceType } from '@lmn/common-search-widget/components/Autocompleter/services/types';

export const isDestinationType = (type: string | PlaceType | undefined): type is PlaceType => {
  const validTypes = ['Airport', 'Anywhere', 'City', 'Country', 'Hotel', 'Region', 'Tag'];
  return validTypes.includes(type as PlaceType);
};

export const isPrompterDestinationOption = (
  option: AutocompleteOption['option'] | undefined
): option is PrompterDestinationOption => (option as PrompterDestinationOption)?.matchInfo !== undefined;

export const isPrompterAirportOption = (option: AutocompleteOption['option']): option is PrompterAirportOption =>
  (option as PrompterAirportOption)?.location !== undefined;
